module.exports = ".cabezera {\n  background: #253a5b;\n  color: white; }\n\n.cabezera-card {\n  border-color: #253a5b; }\n\n.mat-select-arrow {\n  color: white; }\n\n.select-cabezera {\n  color: white; }\n\n.mynewcolor {\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/polizas/polizas-editar/polizas-editar-view/polizas-editar-view.component.scss
// module id = ./src/app/Contabilidad/polizas/polizas-editar/polizas-editar-view/polizas-editar-view.component.scss
// module chunks = main